import ShelfLoading from './ShelfLoading'

export default ShelfLoading
